import React from 'react';

import { withConfig } from '../common/Block.jsx';
import { EmptyContentPlaceholder } from '../layout/Builder.jsx';
import { Carousel } from '../common/Carousel.jsx';
import { default as Image } from '../common/Image.jsx';
import { SliderCellContainer } from './SliderCell.jsx';
import { withSlideshowInitialization } from '../common/Slideshow.jsx';

function SliderComponent(props) {
    return <Carousel.Component {...props} data={props.blockConfig && props.blockConfig.slides} pageData={props.data} slideComponent={SliderCellContainer} />
}

// region LEGACY

const _SliderHelper = {
    isCustomSize: function (size) {
        return size == 1;
    }
};

function _SliderLegacy(props) {
    const ids = props.blockConfig.ids || [];
    if (props.builder && ids.length == 0) {
        return <EmptyContentPlaceholder>This slideshow doesn't have any images yet, but you can add them under the blue settings wheel.</EmptyContentPlaceholder>
    }

    // Slider config
    const handleConfig = function (config) {
        config.dots = false;
        config.loop = true;
        config.nav = true;
        config.navText = false;

        let itemCount = 1;
        if (props.blockConfig.items != undefined) {
            itemCount = props.blockConfig.items;
        }
        config.items = itemCount;

        let autoplayTimeout = 5000;
        if (props.blockConfig.autoplayTimeout != undefined) {
            autoplayTimeout = props.blockConfig.autoplayTimeout;
        }
        config.autoplay = autoplayTimeout != 0;
        config.autoplayTimeout = autoplayTimeout;

        let animateIn, animateOut;
        if (props.blockConfig.animation == 1) {
            animateIn = 'fadeIn';
            animateOut = 'fadeOut';
        }
        config.animateIn = animateIn;
        config.animateOut = animateOut;
    }
    let sliderProps = {};
    if (!props.builder) {
        sliderProps = props.sliderProps['data-owl'] || {};

        React.useEffect(() => {
            props.onRegisterConfigHandler(handleConfig);
        }, []);
    } else if (props.sliderProps['data-owl']) {
        const config = {};
        for (let key in props.sliderProps['data-owl']) {
            config[key] = props.sliderProps['data-owl'][key];
        }
        handleConfig(config);
        sliderProps['data-owl'] = JSON.stringify(config);
    }

    let heightStyle;
    if (_SliderHelper.isCustomSize(props.blockConfig.heightSize) && props.blockConfig.heightUnitValue != undefined) {
        const height = `${props.blockConfig.heightUnitValue}${props.blockConfig.heightUnitType == 1 ? 'vh' : 'px'}`;
        heightStyle = { height: height };
    }
    let widthStyle;
    if (_SliderHelper.isCustomSize(props.blockConfig.widthSize) && props.blockConfig.widthUnitValue != undefined) {
        const width = `${props.blockConfig.widthUnitValue}${props.blockConfig.widthUnitType == 1 ? '%' : 'px'}`;
        widthStyle = { marginLeft: 'auto', marginRight: 'auto', maxWidth: width };
    }
    let itemCount = 1;
    if (props.blockConfig.items != undefined) {
        itemCount = props.blockConfig.items;
    }
    let multiItemSlide = false;
    let sliderClassName = 'slider slider--full__width';
    if (itemCount > 1) {
        multiItemSlide = true;
        sliderClassName += ' slider--multi-item';
    }

    const captions = props.blockConfig.captions || [];
    const extensions = props.blockConfig.extensions || [];
    const hrefs = props.blockConfig.hrefs || [];

    return (
        <div className="cont--slider">
            <div style={widthStyle}>
                <section className="sect--slider" style={heightStyle}>
                    <div id={props.sliderId} className={sliderClassName} style={props.style} {...sliderProps} >
                        {
                            ids.map((d, i) =>
                                <SlideLegacy
                                    key={i}
                                    builder={props.builder}
                                    caption={i < captions.length && captions[i]}
                                    extension={i < extensions.length && extensions[i]}
                                    href={i < hrefs.length && hrefs[i]}
                                    id={d}
                                    imageSize={props.imageSize}
                                    multiItemSlide={multiItemSlide} />)
                        }
                    </div>
                </section>
            </div>
        </div>
    );
}
const SliderLegacy = withConfig(withSlideshowInitialization(_SliderLegacy, {}, false));

function SlideLegacy(props) {
    let clickHandler;
    let href = props.href;
    let style;
    if (props.builder) {
        href = '#';
        style = { pointerEvents: 'none' };
    } else if (!href) {
        clickHandler = (e) => { e && e.preventDefault(); };
        href = '#';
    }
    let image, imageUrl;
    if (props.imageSize) {
        imageUrl = Image.url({ id: props.id, extension: props.extension }, props.imageSize, props.imageSize);
        if (props.multiItemSlide) {
            image = <img src={imageUrl || ''} />;
        } else {
            image = <div className="sect--slider__bg" data-0="transform: translateY(4%);" data-500="transform: translateY(16%);" style={{ backgroundImage: imageUrl ? `url('${imageUrl}')` : undefined }} />
        }
    }
    return (
        <div className="slider__slide">
            <a className="slider__link" href={href} style={style} onClick={clickHandler} aria-label={props.caption || 'Slider Link'}>
                {image}
                <p className="center sect--slider__caption">{props.caption}</p>
            </a>
        </div>
    );
}

export default { Component: SliderComponent, Legacy: SliderLegacy };